import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translations from './translations.json';

i18n.use(initReactI18next).init({
  lng: 'pl',
  fallbackLng: false,
});

export function addTranslations(resources: any): void {
  i18n.addResourceBundle('pl', 'translation', resources, true);
}

addTranslations(translations);
